import type { CurrencyCode } from '@noths/polaris-dev-ts-types';

import { BASKET, BASKET_WITH_OPTIONS } from './graphql/queries';
import type {
  BasketAPIBasketQuery,
  BasketAPIBasketWithItemsQuery,
} from './types/BasketAPIResponseBody';
import { graphqlRequest } from './utils/graphqlRequest';

export interface BasketAPIItemsQueryResponseBody {
  data: {
    basket: BasketAPIBasketQuery;
  };
}

export interface BasketAPIItemsWithOptionsQueryResponseBody {
  data: {
    basket: BasketAPIBasketWithItemsQuery;
  };
}

export const getBasket = async (currencyCode: CurrencyCode): Promise<BasketAPIBasketQuery> => {
  const response = await graphqlRequest<
    BasketAPIItemsQueryResponseBody,
    { currency: CurrencyCode }
  >(BASKET, { currency: currencyCode });

  return response.data.basket;
};

export const getBasketWithItemOptions = async (
  currencyCode: CurrencyCode,
): Promise<BasketAPIBasketWithItemsQuery> => {
  const response = await graphqlRequest<
    BasketAPIItemsWithOptionsQueryResponseBody,
    { currency: CurrencyCode }
  >(BASKET_WITH_OPTIONS, { currency: currencyCode });

  return response.data.basket;
};
